import { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { IoChatbubbles } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import reviewerApi from "../../../api/reviewerApi";
import Pagination from "../../../components/Pagination";

const ReviewdConsents = () => {
  const navigate = useNavigate();
  const [reviewedDocs, setReviewedDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const reviewerEmail = user?.userEmail;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchreviewedDocs = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await reviewerApi.getRevieweDocsByEmail(
          reviewerEmail,
          page,
          pageSize,
          sortedColumn,
          sortOrder,
        );
        const content = response?.data?.content;
        setReviewedDocs(Array.isArray(content) ? content : []);
        setTotalPages(response.data.totalPages || 0);
      } catch (err) {
        setError("Failed to fetch unreviewed documents");
        setReviewedDocs([]);
        setTotalPages(0);
      } finally {
        setLoading(false);
      }
    };

    fetchreviewedDocs();
  }, [reviewerEmail, page, pageSize, sortedColumn, sortOrder]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  // const handleReviewClick = async (
  //   documentId,
  //   documentName,
  //   senderEmail,
  //   companyName,
  //   editedFile
  // ) => {
  //   try {
  //     navigate(
  //       `/dashboard/review-documents/review-file?documentName=${documentName}&documentId=${documentId}&senderEmail=${senderEmail}&companyName=${
  //         companyName || ""
  //       }`,
  //       { state: { editedFile } }
  //     );
  //   } catch (error) {
  //     setError("Failed to fetch document content");
  //   }
  // };
  const handleChatHubClick = (documentId, documentName) => {
    navigate("/dashboard/chat-app-reviewers", {
      state: {
        documentId,
        documentName,
        chatType: "document",
        activeSidebar: "/dashboard/review-documents",
      },
    });
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1)); // Ensure selectedPage is within range
    setPage(selectedPage);
    localStorage.setItem("reviewedDocs", selectedPage); // Store the page number in localStorage
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      // Toggle sort order if the same column is clicked
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Sort by the new column (default to ascending)
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };
  const handleDocumentClick = (consent) => {
    if (!consent.editedFile) {
      Swal.fire("Error", "Document file not available", "error");
      return;
    }

    try {
      const byteCharacters = atob(consent.editedFile);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      // PDF file
      const blob = new Blob([byteArray], {
        type: "application/pdf",
      });

      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank");
    } catch (error) {
      console.error("Failed to open document:", error);
      Swal.fire("Error", "Unable to open document", "error");
    }
  };
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <h2>Reviewed Documents</h2>
      <div style={{ overflowX: "auto", width: "100%" }}>
        <Table
          striped
          bordered
          hover
          style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Document Name</th>
              <th>Company Name</th>
              <th>Sent on</th>
              <th>Sender</th>
              <th>Approved at</th>
              {/* <th>Actions</th> */}
              <th>Chat</th>
            </tr>
          </thead>
          <tbody>
            {reviewedDocs.length > 0 ? (
              reviewedDocs.map((doc, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    {" "}
                    <span
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                      onClick={() => handleDocumentClick(doc)}
                    >
                      {doc.documentName}
                    </span>
                  </td>
                  <td>{doc.companyName || "N/A"}</td>
                  <td>{doc.createdDate}</td>
                  <td>{doc.senderEmail}</td>
                  <td>{doc.approvedAt}</td>
                  <td>
                    <Button
                      variant="secondary"
                      onClick={() =>
                        handleChatHubClick(doc.documentId, doc.documentName)
                      }
                      title="Chat"
                    >
                      <IoChatbubbles />
                    </Button>
                  </td>
                  {/* <td>
                  <Button
                    variant="primary"
                    onClick={() =>
                      handleReviewClick(
                        doc.documentId,
                        doc.documentName,
                        doc.senderEmail,
                        doc.companyName,
                        doc.editedFile
                      )
                    }
                  >
                    <VscPreview />
                  </Button>
                </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No unreviewed documents available</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {reviewedDocs.length > 0 && totalPages > 0 && (
        <div style={{ marginTop: "auto" }}>
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        </div>
      )}
    </div>
  );
};

export default ReviewdConsents;
